<template>
  <div class="full-screen">
    <el-row>
      <el-col :span="16">
        <el-button @click="gobackToEntities()" size="small" v-if="back_button">
          <i class="fa fa-long-arrow-left"></i>
        </el-button>
        <span class="table-head-text" v-if="entity_label">
          {{ getEntityName() }}
        </span>
      </el-col>
      <el-col :span="1" v-if="add_filter">
        <el-badge :value="quickFiltersExternalLength" type="primary">
          <el-tooltip content="Add Filters">
            <button
              class="btn btn-sm btn-outline-secondary m-lr-1"
              type="button"
              @click="openFilterConfig()"
            >
              <i class="fa fa-filter"></i>
            </button> </el-tooltip></el-badge
      ></el-col>
      <el-col :span="1" v-if="settings" style="margin-left: 6px">
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary m-lr-1"
          @click="configSettings()"
        >
          <i class="fa fa-cog fa-spin"></i>
        </button>
      </el-col>
    </el-row>
    <el-row type="flex" justify="end" :gutter="10" style="margin-top: 6px">
      <el-col :span="4" v-if="filter_list && quickFiltersExternal.length"
        ><ExternalEntityFilterList
          :currentFilter="currentFilter"
          :quickFiltersExternal="quickFiltersExternal"
          @filter-change="handleFilter"
        ></ExternalEntityFilterList
      ></el-col>
      <el-col :span="5"
        ><el-input
          placeholder="Search"
          size="small"
          clearable
          prefix-icon="el-icon-search"
          v-if="searchableorNot()"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            size="mini"
          ></el-button> </el-input></el-col
    ></el-row>
    <el-row
      style="margin-top: 7px"
      type="flex"
      justify="end"
      :gutter="10"
      v-if="allQuickFilters.length"
    >
      <el-col :span="4" v-for="(filter, index) in allQuickFilters" :key="index"
        ><ExternalEntityQuickFilter
          :filter_form="filter_form"
          :currentEntity="currentEntity"
          :filterDetails="filter.application_filter"
          :filter_key="filter.api_filter_key"
          :placeholder="'By ' + filter.application_filter.orgLabel"
          @quick-filter-change="quickFilterChange"
        ></ExternalEntityQuickFilter>
      </el-col>
    </el-row>
    <el-row
      class="infinite-scroll-container"
      v-infinite-scroll="loadMore"
      :infinite-scroll-disabled="infinite_loading || !hasMoreRecords"
      infinite-scroll-immediate="false"
      infinite-scroll-distance="50"
      style="margin-top: 6px"
      v-loading="loading"
      :element-loading-text="loadingText"
    >
    <el-scrollbar
        style="height: 100%">
      <el-table
        :data="tableData"
        border
        size="mini"
        style="width: 99%"
        @sort-change="handleSortChange"
      >
        <el-table-column
          v-for="(column, index) in getColumns"
          :key="index"
          :prop="column.key"
          :label="column.label"
          :column-key="column.template_id + '#' + column.key"
          min-width="250"
          :sortable="checkSortableorNot(column)"
        >
          <template slot-scope="scope">
            <div v-if="column && column.type == 'ACTION_BUTTON'">
              <el-button
                type="text"
                @click="actionExecute(column, scope.row, scope.$index)"
              >
                {{ column.label }}
              </el-button>
            </div>
            <div
              v-else-if="
                column &&
                column.type == 'DATE' &&
                scope.row[column.template_id + '#' + column.key]
              "
            >
              {{
                scope.row[column.template_id + "#" + column.key]
                  | globalDateFormat
              }}
            </div>
            <div v-else>
              {{ scope.row[column.template_id + "#" + column.key] }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-scrollbar>
    </el-row>
    <dialog-component
      title="Add Filters"
      :visible.sync="openFilterConfiguration"
      :containerWidth="getIsMobile ? '100%' : '70%'"
      @before-close="cancel()"
    >
      <div style="margin: 1%">
        <ExternalEntityFilter
          :externalFilters="externalFilters"
          :quickFilterFields="quickFilterFields"
          :externalFilterInfo="externalFilterInfo"
          placeholder="select Field"
          :edit_filter="currentFilter ? true : false"
          @delete-filter="deleteFilter"
        ></ExternalEntityFilter>
      </div>
      <span slot="footer" class="dialog-footer">
        <button
          class="btn btn btn-outline-danger btn-sm m-lr-1"
          type="button"
          @click="cancel"
        >
          <i class="fa fa-close"></i> Cancel
        </button>
        <button
          class="btn btn btn-outline-success btn-sm m-lr-1"
          type="button"
          :disabled="enableSaveButton"
          @click="saveFilter"
        >
          <i class="fa fa-check-square-o"></i> {{ getButtonName() }}
        </button>
      </span>
    </dialog-component>
    <dialog-component
      title="View Fields"
      :visible.sync="openSettings"
      :containerWidth="getIsMobile ? '100%' : '70%'"
      @before-close="cancelSettings()"
    >
      <div style="margin: 1%">
        <ExternalSourceSettings
          :data="treeData"
          :defaultProps="{ children: 'children', label: 'label' }"
          :settings="checkedKeys"
          @handle-settings="handleSettings"
        ></ExternalSourceSettings>
      </div>
      <span slot="footer" class="dialog-footer">
        <button
          class="btn btn-outline-primary btn-sm m-lr-1"
          type="button"
          @click="saveSettings"
        >
          <i class="fa fa-rocket fa-fade"></i> &nbsp; Apply.....
        </button>
      </span>
    </dialog-component>
    <div v-if="quickActionModal && quickActionDummyField">
      <ActionButtonExecute
        :data="quickActionDummyField"
        :isView="false"
        :entityId="currentEntity._id"
        :fromQuickAction="true"
        :entityData="rowEntityData"
        :selfTemplateId="quickActionDummyField.template_id"
        :allEntityFields="selectedEntityFields"
        :form="quickActionDummyForm"
        @closeModal="quickActionModal = false"
        :entityDetails="currentEntity"
        :external_source="true"
      >
      </ActionButtonExecute>
    </div>
  </div>
</template>
<script>
import { fetchEntityById } from "@/repo/entityRepo";
import { fetchAllEntityFiltersByEntity } from "@/repo/filtersRepo";
import {
  macthedEvent,
  getRealData,
  getIntegrationInfo,
} from "../../helpers/integrationHelper";
import CustomDashboardConfig from "@/mixins/CustomDashboardHelper.js";
import EntityHelper from "@/mixins/EntitiesHelper";
import axios from "@/config/axios";
import { postAPICall } from "../../helpers/httpHelper";
import { dataTableAllowedExcecuteFields } from "../templates/formComponentsExecute";
export default {
  props: {
    back_button: Boolean,
    entity_label: Boolean,
    add_filter: Boolean,
    settings: Boolean,
    filter_list: Boolean,
    entity_id: String,
    sort_order: String,
    sort_column: String,
    currentPage: Number,
    limit: Number,
    currentFilter: String,
    relationalEntityId: String,
    relationalEntityData: Object,
  },
  mixins: [CustomDashboardConfig, EntityHelper],
  data() {
    return {
      infinite_loading: false,
      treeData: [],
      filter_form: {},
      quickFiltersExternalLength: 0,
      quickFiltersExternal: [],
      getIsMobile: false,
      openFilterConfiguration: false,
      loading: false,
      loadingText: "Loading...",
      paginationProps: [5, 10, 20, 50, 100],
      search_string: "",
      currentEntity: null,
      connectionInfo: [],
      total: 0,
      tableData: [],
      columns: [],
      externalFilterInfo: {
        filter_name: "",
        externalQuickFilters: {},
        entity_id: "",
      },
      quickFilterFields: [],
      externalFilters: [],
      allQuickFilters: [],
      eventDetails: null,
      openSettings: false,
      selectedEntityFields: [],
      quickActionDummyField: null,
      quickActionModal: false,
      quickActionDummyForm: {},
      rowEntityData: {},
      refresh: false,
      hasMoreRecords: true,
    };
  },
  components: {
    ExternalEntityFilter: () => import("./externalEntityFilters.vue"),
    ExternalEntityFilterList: () => import("./externalFiltersList.vue"),
    ExternalEntityQuickFilter: () => import("./externalEntityQuickFilter.vue"),
    ExternalSourceSettings: () => import("./externalSourceSettings.vue"),
    ...dataTableAllowedExcecuteFields,
  },
  async mounted() {
    await this.getAllData();
  },
  computed: {
    checkedKeys() {
      return this.currentEntity?.settings.map((item) => item.id);
    },
    isApplicationUser() {
      return this.$route.name === "application-user-external-entity";
    },
    getColumns() {
      return this.retrieveColumns();
    },
    enableSaveButton() {
      let allFiltersMapped = this.externalFilters.every(
        (filter) => this.externalFilterInfo.externalQuickFilters[filter.key]
      );
      if (
        this.externalFilterInfo &&
        this.externalFilterInfo.filter_name &&
        allFiltersMapped
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    async loadMore() {
      try {
        this.infinite_loading = true;
        await this.loadData();
        this.$emit("page-apply", this.currentPage + 1);
        this.infinite_loading = false;
      } catch (err) {
        this.infinite_loading = false;
      }
    },
    async actionExecute(col, row, index) {
      let copiedRow = JSON.parse(JSON.stringify(row));
      let templatesData = {};
      this.selectedEntityFields.forEach((field) => {
        if (!templatesData[field.template_id]) {
          templatesData[field.template_id] = {};
        }
        templatesData[field.template_id][field.key] =
          copiedRow[field.template_key];
        if (field.input_type === "ENTITY") {
          templatesData[field.template_id][`${field.key}/name`] =
            copiedRow[`${field.template_key}`];
          templatesData[field.template_id][`${field.key}`] = "";
        }
      });
      let rowColumns = Object.keys(copiedRow);
      let entityFields = rowColumns
        .map((col) => this.getField(col))
        .filter((field) => field && field.input_type === "ENTITY");
      templatesData = await this.getEntityFieldsIds(
        entityFields,
        templatesData
      );
      copiedRow["entityData"] = templatesData;
      this.onActionButtonOpen(col, copiedRow, index);
    },
    async getEntityFieldsIds(entityFields, templatesData) {
      try {
        await Promise.allSettled(
          entityFields.map(async (field) => {
            let params = {
              entity_id: field.entity_id,
              filters: [],
              primary_search_fields: [field.primary_fields[0]],
              search_string:
                templatesData[field.template_id][field.key + "/name"],
              page: 1,
              limit: 1,
            };
            let result = await this.getEntityData(params);
            if (result.data.length && result.data[0]._id) {
              templatesData[field.template_id][`${field.key}`] =
                result.data[0]?._id;
            }
          })
        );
        return templatesData;
      } catch (err) {
        console.log("err", err);
      }
    },
    async getEntityData(params) {
      try {
        let response = await postAPICall(
          "POST",
          "/entities-data/entity/data/v2",
          params
        );
        return response.data;
      } catch (err) {
        console.log("Err", err);
      }
    },
    handleSettings(data) {
      this.currentEntity.settings = data;
    },
    async getEntityFields() {
      let templates = this.currentEntity.templates.map((temp) => {
        return {
          id: temp.template_id,
          label: temp.templateInfo.name,
          children: temp.templateInfo.sections[0].fields.map((field) => {
            return {
              label: field.label,
              id: field.key,
              key: field.key,
              type: field.input_type,
              input_type: field.input_type,
              template_id: temp.template_id,
              template_name: temp.templateInfo.name,
            };
          }),
        };
      });
      this.treeData = templates;
    },
    async saveSettings() {
      try {
        await postAPICall(
          "PUT",
          `/entities/${this.currentEntity._id}`,
          this.currentEntity
        );
        this.openSettings = false;
      } catch (err) {
        this.$notify({
          title: "Filter Error",
          message: err?.response?.data?.message || `Failed to update filter`,
          type: "error",
        });
        throw err;
      }
    },
    cancelSettings() {
      this.openSettings = false;
    },
    async configSettings() {
      await this.getEntityFields();
      this.openSettings = true;
    },
    async deleteFilter() {
      try {
        this.$confirm("Are you sure to delete this filter", "Warning", {
          confirmButtonText: "Ok",
          cancelButtonText: "Cancel",
          type: "warning",
        }).then(async () => {
          await this.deleteFilterApi();
          this.$emit("update-filter", "");
          this.$notify({
            title: "Success",
            message: "Filter deleted",
            type: "success",
          });
          this.openFilterConfiguration = false;
          this.allQuickFilters = [];
          this.reset_filter();
          this.resetFilterConfig();
          this.getAllEntityFilters();
        });
      } catch (Err) {
        console.log("Err", Err);
      }
    },
    async deleteFilterApi() {
      try {
        let response = await postAPICall(
          "DELETE",
          `/entity-filter/${this.currentFilter}`
        );
        return response;
      } catch (err) {
        console.log("delte-filter-err", err);
        this.$notify({
          title: "Filter Error",
          message: err?.response?.data?.message || `Failed to delete filter`,
          type: "error",
        });
        throw err;
      }
    },
    getButtonName() {
      return this.currentFilter ? "Update" : "Save";
    },
    async handleSortChange({ column, order }) {
      try {
        this.$emit("sort-column-order-apply", column, order);
        this.$emit("page-apply", 1);
        this.reset_table();
        this.loading = true;
        await this.loadData();
        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
    searchableorNot() {
      let macthedEventDetails = this.eventDetails;
      if (macthedEventDetails && macthedEventDetails.settings.searchable) {
        return true;
      } else {
        return false;
      }
    },
    checkSortableorNot(column) {
      let apiColumn =
        this.currentEntity.external_config.mappingConfig[
          `${column.template_id}#${column.key}`
        ];
      let macthedEventDetails = this.eventDetails;
      let isSortable = macthedEventDetails?.settings?.availableColumns.find(
        (col) => col.sortable && col.key === apiColumn
      );
      return isSortable ? "custom" : false;
    },
    gobackToEntities() {
      this.$router.push({ path: "/entity" });
    },
    verifyAllFiltersApplied() {
      try {
        let macthedEventDetails = this.eventDetails;
        let apiFilters = macthedEventDetails.settings.requiredFields || [];
        if (apiFilters.length && this.currentFilter) {
          return apiFilters.every((filter) => this.filter_form[filter.key]);
        } else if (!apiFilters.length) {
          return true;
        } else {
          return false;
        }
      } catch (err) {
        console.log("filter-validation-err", err);
      }
    },
    async quickFilterChange() {
      try {
        this.reset_table();
        let isSatisfied = this.verifyAllFiltersApplied();
        if (isSatisfied) {
          this.loading = true;
          await this.getExternalData();
          this.loading = false;
        }
        return;
      } catch (err) {
        this.loading = false;
      }
    },
    async loadData() {
      let isSatisfied = this.verifyAllFiltersApplied();
      if (isSatisfied) {
        await this.getExternalData();
      }
      return;
    },
    handleFilter(filterId) {
      this.reset_filter();
      this.$emit("update-filter", filterId);
      this.addQuickFilters();
    },
    async addQuickFilters() {
      try {
        let filterInfo = this.quickFiltersExternal.find(
          (filter) => filter._id === this.currentFilter
        );
        if (!filterInfo) {
          return;
        }
        this.externalFilterInfo = filterInfo;
        let { externalQuickFilters } = filterInfo;
        if (!externalQuickFilters) {
          return;
        }
        let allFiltersKeys = Object.keys(externalQuickFilters);
        await Promise.all(
          allFiltersKeys.map(async (filterKey) => {
            const fieldInfo = this.selectedEntityFields.find(
              (f) => f.template_key === externalQuickFilters[filterKey]
            );
            if (!fieldInfo) return;
            const haveRelation = await this.verifyRelation(
              fieldInfo,
              filterKey
            );
            if (!haveRelation) {
              this.allQuickFilters.push({
                application_filter: fieldInfo,
                api_filter_key: filterKey,
              });
            }
          })
        );
      } catch (err) {
        console.log("Err", err);
        throw err;
      }
    },
    async verifyRelation(fieldInfo, filterKey) {
      try {
        let relationalEntity =
          fieldInfo.input_type === "ENTITY" &&
          fieldInfo.entity_id === this.relationalEntityId;
        if (relationalEntity) {
          this.$set(
            this.filter_form,
            filterKey,
            this.relationalEntityData[fieldInfo.primary_fields[0]]
          );
          return true;
        }
        return false;
      } catch (err) {
        console.log("err");
        throw err;
      }
    },
    reset_filter() {
      this.allQuickFilters = [];
      this.filter_form = {};
      this.reset_table();
    },
    reset_table() {
      this.tableData = [];
      this.$emit("page-apply", 1);
    },
    async saveFilter() {
      try {
        let name = this.getButtonName();
        if (name === "Update") {
          await this.updateFilter();
        } else {
          await this.createFilter();
        }
        this.openFilterConfiguration = false;
        this.resetFilterConfig();
        this.getAllEntityFilters();
      } catch (err) {
        console.log("Err", err);
      }
    },
    async createFilter() {
      try {
        this.externalFilterInfo["entity_id"] = this.currentEntity._id;
        await axios.post("entity-filter", this.externalFilterInfo);
        this.$notify({
          title: "Success",
          message: "Filters saved",
          type: "success",
        });
      } catch (err) {
        this.$notify({
          title: "Filter Error",
          message: err?.response?.data?.message || `Failed to save filter`,
          type: "error",
        });
      }
    },
    async updateFilter() {
      try {
        await axios.post(
          `entity-filter/${this.currentFilter}`,
          this.externalFilterInfo
        );
        this.$notify({
          title: "Success",
          message: "Filter Updated",
          type: "success",
        });
      } catch (err) {
        this.$notify({
          title: "Filter Error",
          message: err?.response?.data?.message || `Failed to update filter`,
          type: "error",
        });
      }
    },
    resetFilterConfig() {
      this.externalFilterInfo = {
        filter_name: "",
        externalQuickFilters: {},
        entity_id: "",
      };
    },
    cancel() {
      this.openFilterConfiguration = false;
      this.resetFilterConfig();
    },
    async openFilterConfig() {
      try {
        this.quickFilterFields = this.selectedEntityFields?.filter(
          (f) => f.input_type === "ENTITY"
        );
        let macthedEventDetails = this.eventDetails;
        this.externalFilters = macthedEventDetails.settings.requiredFields;
        this.openFilterConfiguration = true;
      } catch (err) {
        console.log("config-error", err);
      }
    },
    getEntityName() {
      return this.currentEntity?.name;
    },
    retrieveColumns() {
      const excluded = ["created_at", "updated_at"];
      return this.currentEntity?.settings.filter(
        (col) => !excluded.includes(col.id)
      );
    },
    async getAllData() {
      try {
        this.loading = true;
        this.loadingText = "Loading Data from External Source";
        await Promise.all([
          this.fetchEntityDetailss(),
          this.getAllEntityFilters(),
        ]);
        await this.fetchFields();
        await this.getIntegration();
        this.macthedEventInfo();
        await this.addQuickFilters();
        await this.loadData();
        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
    async fetchFields() {
      try {
        let allEntityFields = await this.fetchEntityDetails(
          this.currentEntity._id,
          false,
          false,
          false,
          false,
          false,
          false
        );
        this.selectedEntityFields = allEntityFields;
      } catch (err) {
        console.log("Err", err);
      }
    },
    async handleCurrentChange(value) {
      try {
        this.$emit("page-apply", value);
        let satisfied = this.verifyAllFiltersApplied();
        if (satisfied) {
          this.loading = true;
          await this.getExternalData();
          this.loading = false;
        }
        return;
      } catch (err) {
        this.loading = false;
      }
    },
    async handleSizeChange(value) {
      try {
        this.$emit("page-limit-apply", value);
        let satisfied = this.verifyAllFiltersApplied();
        if (satisfied) {
          this.loading = true;
          await this.getExternalData();
          this.loading = false;
        }
        return;
      } catch (err) {
        this.loading = false;
      }
    },
    async getIntegration() {
      try {
        let integrationConfigInfo = this.currentEntity.external_config;
        let { integration } = integrationConfigInfo;
        let result = await getIntegrationInfo(integration);
        this.connectionInfo = result;
      } catch (err) {
        console.log("err", err);
        throw err;
      }
    },
    macthedEventInfo() {
      let integrationConfigInfo = this.currentEntity.external_config;
      let { event } = integrationConfigInfo;
      this.eventDetails = macthedEvent(this.connectionInfo.application, event);
    },
    async getAllEntityFilters() {
      try {
        let allFilters = await fetchAllEntityFiltersByEntity({
          entityId: this.entity_id,
        });
        this.quickFiltersExternal = allFilters;
      } catch (err) {
        console.log("allFilters-error", err);
        throw err;
      }
    },
    async fetchEntityDetailss() {
      try {
        let entityInfo = await fetchEntityById(this.entity_id);
        this.currentEntity = entityInfo;
        return;
      } catch (err) {
        console.log("err", err);
        throw err;
      }
    },
    async getExternalData() {
      try {
        let integrationConfigInfo = this.currentEntity.external_config;
        let { application, integration } = integrationConfigInfo;
        let macthedEventDetails = this.eventDetails;
        let apiColumn = integrationConfigInfo.mappingConfig[this.sort_column];
        let matchedField = macthedEventDetails.settings.availableColumns.find(
          (field) => field.key === apiColumn
        );
        let sort_order;
        let sort_column;
        if (matchedField && matchedField.sortable) {
          sort_order =
            this.sort_order === "ascending"
              ? matchedField.sort_order_asc
              : matchedField.sort_order_dsc;
          sort_column = matchedField.sort_value;
        } else {
          sort_order = "";
          sort_column = "";
        }
        let payload = {
          asset: macthedEventDetails.asset,
          provider: application,
          connectionId: integration,
          dependencies: this.filter_form,
          fields: [],
          pagination: {
            page: this.currentPage,
            pageSize: this.limit,
          },
          sort_by: sort_column,
          sort_order: sort_order,
        };
        let result = await this.fetchAllData(payload);
        const mappedData = this.getMappedData(
          this.currentEntity.external_config.mappingConfig,
          result.rows
        );
        let validEntityFields = this.selectedEntityFields.filter((field) => {
          return (
            field.input_type === "ENTITY" &&
            this.currentEntity.external_config.mappingConfig[field.template_key]
          );
        });
        if (validEntityFields.length) {
          await Promise.all(
            validEntityFields.map(async (field) => {
              const primaryDataValues = mappedData.map(
                (data) => data[field.template_key]
              );
              const params = {
                entity_id: field.entity_id,
                limit: mappedData.length,
                page: 1,
                filters: [
                  {
                    field: field.primary_fields[0],
                    operator: "in",
                    value: primaryDataValues,
                  },
                ],
                template_fields_data: [
                  {
                    template_id: field.primary_fields[0].split("#")[0],
                    fields: [field.primary_fields[0].split("#")[1]],
                  },
                ],

                fields: [field.primary_fields[0]],
              };

              const result = await this.getEntityData(params);
              const validValues = new Set(
                result.data.map(
                  (item) => item.templates_fields_data[field.primary_fields[0]]
                )
              );
              this.tableData = [
                ...this.tableData,
                ...mappedData.filter((row) =>
                  validValues.has(row[field.template_key])
                ),
              ];
            })
          );
        } else {
          this.tableData = [...this.tableData, ...mappedData];
        }
        if (result.rows.length < this.limit) {
          this.hasMoreRecords = false;
        }
        return;
      } catch (err) {
        console.log("Errr", err);
        throw err;
      }
    },
    async fetchAllData(payload) {
      try {
        return await getRealData(payload);
      } catch (error) {
        console.log("error", error);
        throw error;
      }
    },
    getMappedData(mappingConfig, data) {
      try {
        return data.map((item) => {
          const mapped = {};
          for (const [key, sourceField] of Object.entries(mappingConfig)) {
            mapped[key] = item[sourceField] ?? "";
          }
          return mapped;
        });
      } catch (Err) {
        console.log("Err", Err);
        throw Err;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.full-screen {
  min-height: 100vh; /* full screen height */
  width: 100%; /* full screen width */
  background-color: #ffffff; /* your color */
}
.table-head-text {
  white-space: nowrap;
  font-size: 1.14rem;
  font-weight: 600;
  color: #677788;
}
.el-table {
  border-radius: 10px;
  overflow: hidden;
}
/* Chrome / Edge / Safari */
::v-deep .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar {
  height: 6px; /* scrollbar thickness */
}

::v-deep
  .el-table--scrollable-x
  .el-table__body-wrapper::-webkit-scrollbar-track {
  background: transparent; /* remove any track background */
}

::v-deep
  .el-table--scrollable-x
  .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 6px; /* rounded edges */
  border: none; /* ensure no border */
}

/* Firefox */
::v-deep .el-table--scrollable-x .el-table__body-wrapper {
  scrollbar-width: thin;
  scrollbar-color: #999 transparent; /* thumb | track */
}
.custom-pagination {
  padding: 10px;
  margin-left: 27%;
}
.infinite-scroll-container {
  height: 400px; /* make scrollable */
  overflow-y: auto;
}
</style>
